import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../services/snackbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { FacturaGestorAcuerdoControllerService, FacturaPoseedorEstadosControllerService, FacturaGestorAcuerdoFilterDTO, FacturaEstadoDTO } from 'api-rest';
import { DownloadService } from '../../services/download.service';

@Component({
  selector: 'managers-agreements-managers-agreements-invoice-accounting-dialog',
  templateUrl: './managers-agreements-invoice-accounting-dialog.component.html',
  styleUrls: ['./managers-agreements-invoice-accounting-dialog.component.scss']
})
export class ManagersAgreementsInvoiceAccountingDialogComponent implements OnInit {
  formGroup!: FormGroup;

  estadoArray: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ManagersAgreementsInvoiceAccountingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
    private facturaGestorAcuerdoControllerService: FacturaGestorAcuerdoControllerService,
    private facturaPoseedorEstadosControllerService: FacturaPoseedorEstadosControllerService,
    private downloadService: DownloadService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
  ) {
    this.formGroup = this.formBuilder.group({
      anio: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      aceptada: [
        { value: null, disabled: false },
      ],
      registradas: [
        { value: null, disabled: false },
      ],
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.facturaPoseedorEstadosControllerService.findAll11().subscribe({
      next: (data: Array<FacturaEstadoDTO>) => {
        this.estadoArray = data!;
      },
      error: () => { },
    });
  }

  generarInforme() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      this.spinnerSrv.loadingShow();
      let filter: FacturaGestorAcuerdoFilterDTO = {
        anioPrefactura: this.formGroup.get('anio')?.value
      };
      if (this.formGroup.get('aceptada')?.value) {
        filter.estado = this.estadoArray.filter((item: any) => item.id == 3)[0];
      }
      if (this.formGroup.get('registradas')?.value) {
        filter.registrada = this.formGroup.get('registradas')?.value;
      }
      this.facturaGestorAcuerdoControllerService
        .informeContabilizacion(filter, 'response')
        .subscribe({
          next: (res: any) => {
            this.spinnerSrv.loadingHide();
            const filename = this.downloadService.getFileName(
              res.headers,
              'Informe contabilizacion.xlsx'
            );
            this.downloadService.downloadBlob(res.body!, filename!);
            this.dialogRef.close();
            this.snackBarSrv.showSnackBar('El informe de contabilización se ha generado correctamente', 'success');
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al generar el informe de contabilización', 'error');
          },
        });
    }
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

}
